import styled from 'styled-components';

export const ThumbnailsWrapper = styled.div`
  width: calc(100% - 20px);
  padding: 10px 0px;
  display: flex;
  gap: 10px;
  margin-left: 10px;
  overflow-x: scroll;

  ::-webkit-scrollbar {
    background-color: transparent;
    display: block;
    width: 7px;
    height: 7px;
  }

  ::-webkit-scrollbar-thumb {
    background-color: #ccc;
    border-radius: 1em;
  }

  ::-webkit-scrollbar-track {
    border-radius: 1em;
    margin-top: 5px;
    margin-left: 5px;
  }

  ::-webkit-scrollbar-track-piece :end {
    background-color: transparent;
    margin-bottom: 10px;
  }

  ::-webkit-scrollbar-track-piece :start {
    background-color: transparent;
    margin-bottom: 10px;
  }

  ::-webkit-scrollbar-corner {
    background-color: transparent;
  }
`;

export const Image = styled.img`
  height: calc(${({ altura }) => altura} - 75px);
  cursor: pointer;
  border-radius: 2px;
`;
